import format from 'date-fns/format';

export const dateToLocalDateTime = (date: Date) => format(date, 'MMMM d, yyyy');
